import FundTrusteeCorporate from '@/app/modules/fund/components/fund-trustee-corporate/fund-trustee-corporate.vue';
import FundTrusteeIndividual from '@/app/modules/fund/components/fund-trustee-individual/fund-trustee-individual.vue';

const trusteeSelections = [
  {
    name: 'Corporate',
    slug: 'corporate',
    trustee: 'directors',
    icon: 'brief-case',
  },
  {
    name: 'Individual',
    slug: 'individual',
    trustee: 'trustees',
    icon: 'person',
  },
];

export default {
  name: 'fund-trustee',
  components: {
    FundTrusteeCorporate,
    FundTrusteeIndividual,
  },
  data: () => ({
    trusteeSelections,
  }),
  computed: {
    trusteeSelected: {
      get() {
        return this.$store.getters['fund/getFund'].trustee.type;
      },
      set(value) {
        // Adding members to trustees as per business requirement
        // re once selected trustee type auto load members
        this.$store.dispatch('fund/updateFundTrustee', { type: value, trustees: [...this.members], company: { name: '' } });
      },
    },
    members() {
      return this.$store.getters['fund/getFund'].members;
    },
    trustees() {
      return this.$store.getters['fund/getFund'].trustee.trustees;
    },
  },
  methods: {
    backStep() {
      this.$emit('backStep');
    },
    nextStep() {
      this.$emit('nextStep');
    },
  },
  async activated() {
    const fixedTrustees = [];
    this.trustees.forEach((trustee) => {
      let checked = false;
      this.members.forEach((member) => {
        // eslint-disable-next-line max-len
        if (trustee.integrationId !== undefined && member.integrationId !== undefined && trustee.integrationId === member.integrationId) {
          fixedTrustees.push(member);
          checked = true;
        }
      });
      if (!checked) {
        fixedTrustees.push(trustee);
      }
    });
    if (fixedTrustees.length > 0) {
      await this.$store.dispatch('fund/updateFundTrustee', { trustees: fixedTrustees });
    }
  },
};
